import React from 'react';
import { Navigate } from 'react-router';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class AnnualClose extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            systemModuleId: 4,
            moduleAccessStatus: 1,
            menuId: 112,
            newAnnualTitle: '',
            newAnnualFrom: null,
            newAnnualTo: null,
            sodoZiyanAnbashteMoeinId: '',
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.httpPost("api/v1/annual/getclose", {})
                    .then(data => {
                        if (data.status === -1) window.location.href = "/login";
                        if (data.status === 1) {
                            window.organizationId = data.global.company.id;
                            this.state.data = data;
                            this.state.newAnnualFrom = data.newAnnualFrom;
                            this.state.newAnnualTo = data.newAnnualTo;
                            this.setState({ loading: false });
                        }
                        else {
                            this.showErorrMessage(data.message);
                            this.setState({
                                loading: false
                            });
                        }
                    });
            });
    }
    save() {
        this.httpPost("api/v1/annual/saveclose", {
            organizationId: this.state.data.global.company.id,
            newAnnualTitle: this.state.newAnnualTitle,
            newAnnualFrom: this.convertMomentToDb(this.state.newAnnualFrom),
            newAnnualTo: this.convertMomentToDb(this.state.newAnnualTo),
            sodoZiyanAnbashteMoeinId: this.state.sodoZiyanAnbashteMoeinId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("عملیات با موفقیت انجام پذیرفت");
                    window.location.href = "/documents/";
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="container-fluid">
                            {this.state.data.annual.closed ?
                                <p style={{ "background-color": "#f6e7ed", "border": "1px solid #b22a3d" }} >
                                    <span className="fa fa-warning-circle fa-2x" style={{ "color": "#b22a3d" }} >
                                    </span>&nbsp;&nbsp;
                                    <span>عملیات پایان دوره قبلا برای این سال مالی انجام پذیرفته است</span>
                                </p>
                                :
                                <div className="p-2">
                                    <p>
                                        <span className="fa fa-info-circle fa-2x" style={{ "color": "#2ab27b" }} ></span>&nbsp;&nbsp;
                                        <span>توجه": "قبل از بستن دوره مالی، ترازنامه و مانده حسابهای خود را بررسی کنید و در صورت نیاز ثبت های اصلاحی را انجام دهید.</span>
                                    </p>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <label>نام دوره مالی جاری:</label> {this.state.data.annual.title}
                                        </div>
                                        <div className="col-sm-4">
                                            <label>تاریخ شروع:</label> {this.state.data.annual.fromPersian}
                                        </div>
                                        <div className="col-sm-4">
                                            <label>تاریخ پایان:</label> {this.state.data.annual.toPersian}
                                        </div>
                                    </div>
                                    <div className="row" style={{ "marginTop": "10px" }}>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label>نام دوره مالی جدید:</label>
                                                <input defaultValue={this.state.newAnnualTitle} onChange={e => this.state.newAnnualTitle = e.target.value} autocomplete="off" type="text" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label>تاریخ شروع:</label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"انتخاب تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.newAnnualFrom = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.newAnnualFrom)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label>تاریخ پایان:</label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"انتخاب تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.newAnnualTo = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.newAnnualTo)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ "marginTop": "10px" }}>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label>معین سود و زیان انباشته:</label>
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={null}
                                                isMulti={false}
                                                placeholder="انتخاب معین"
                                                defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
                                                    onChange={e => this.state.sodoZiyanAnbashteMoeinId = e.value}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row text-center">
                                        <a onClick={e => this.save()} autocomplete="off" className="btn btn-primary">بستن دوره مالی و ایجاد دوره مالی جدید</a>
                                    </div>
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}